import "./Header.css"


const Header = () => {
    

    return (
        <>
        <div className="Main-header">
                <h1>The Movies</h1>
        </div>
        <div>

        </div>
        </>
        
    
            
        
    )
}

export default Header